// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import axios, { AxiosInstance, AxiosResponse, AxiosRequestConfig } from 'axios';
import * as FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
    GatewayError,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
export class PrescriptionV1Api {
    protected authentications: {
        'Token': Authentication;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
        };
        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @param accountId generated
     * @param x_tc_scopeid generated
     * @param x_tc_scopetype generated
     */
    public async accountPrescriptionGet (accountId: string, x_tc_scopeid?: string, x_tc_scopetype?: string): Promise<AxiosResponse> {
        const _url_ = '/prescription/v1/AccountPrescription/{accountId}'
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)));
        let _params_: any = {};
        let _headers_: any = {};

        // verify required parameter 'accountId' is not null or undefined
        if (accountId === null || accountId === undefined) {
            throw new Error('Required parameter accountId was null or undefined when calling accountPrescriptionGet.');
        }

        _headers_['x-tc-scopeid'] = Serializer.serialize(x_tc_scopeid, "string");
        _headers_['x-tc-scopetype'] = Serializer.serialize(x_tc_scopetype, "string");

        let requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
    /**
     * 
     * @param ndcCode generated
     * @param x_tc_scopeid generated
     * @param x_tc_scopetype generated
     */
    public async code (ndcCode?: string, x_tc_scopeid?: string, x_tc_scopetype?: string): Promise<AxiosResponse<object>> {
        const _url_ = '/prescription/v1/NdcCode';
        let _params_: any = {};
        let _headers_: any = {};

        if (ndcCode !== undefined) {
            _params_['ndcCode'] = Serializer.serialize(ndcCode, "string");
        }

        _headers_['x-tc-scopeid'] = Serializer.serialize(x_tc_scopeid, "string");
        _headers_['x-tc-scopetype'] = Serializer.serialize(x_tc_scopetype, "string");

        let requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<object>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "object");
        }
        return response;
    }
    /**
     * 
     * @param ndcId generated
     * @param x_tc_scopeid generated
     * @param x_tc_scopetype generated
     */
    public async id (ndcId?: string, x_tc_scopeid?: string, x_tc_scopetype?: string): Promise<AxiosResponse<object>> {
        const _url_ = '/prescription/v1/NdcId';
        let _params_: any = {};
        let _headers_: any = {};

        if (ndcId !== undefined) {
            _params_['ndcId'] = Serializer.serialize(ndcId, "string");
        }

        _headers_['x-tc-scopeid'] = Serializer.serialize(x_tc_scopeid, "string");
        _headers_['x-tc-scopetype'] = Serializer.serialize(x_tc_scopetype, "string");

        let requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<object>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "object");
        }
        return response;
    }
    /**
     * 
     * @param x_tc_scopeid generated
     * @param x_tc_scopetype generated
     * @param x_program_id The program id from the list of allowed program ids
     */
    public async programIdByProgramId (x_tc_scopeid?: string, x_tc_scopetype?: string, x_program_id?: number): Promise<AxiosResponse<object>> {
        const _url_ = '/prescription/v1/NdcprogramId';
        let _params_: any = {};
        let _headers_: any = {};

        _headers_['x-tc-scopeid'] = Serializer.serialize(x_tc_scopeid, "string");
        _headers_['x-tc-scopetype'] = Serializer.serialize(x_tc_scopetype, "string");
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "number");

        let requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<object>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "object");
        }
        return response;
    }
}
